module.exports = __webpack_public_path__ + "img/horizontal_7_2_3.ac56b1eb.png";